import { Stack } from "@mui/material";
import { InputControl } from "../../../shared";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const NameDialog = (props) => {
  const {
    onChange,
    onSubmit,
    state,
    // isEdit,
    validator,
    handleClose,
    isDisabled,
  } = props;
  const { data } = state;
  return (
    <>
      <Stack px="16px">
        <InputControl
          sx={{ width: "442px", mt: "16px" }}
          autoFocus
          margin="dense"
          label=" Template Name"
          name="template_name"
          required
          onChange={onChange}
          value={state?.data?.template_name}
          error={validator.current.message(
            "name",
            data?.template_name,
            "required"
          )}
          helperText={validator.current.message(
            "name",
            data?.template_name,
            "required"
          )}
        />
      </Stack>
      <CustomDialogFooter
        handleClose={handleClose}
        onSubmit={onSubmit}
        disabled={isDisabled}
      />
    </>
  );
};
